<template>
  <div>
    <h2 id="scrollToTop" class="mt-6 mb-2">
      {{ $t("consultByRegistrationDate") }}
    </h2>
    <v-card>
      <div class="pa-3 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="6" xs="6">
            <div
              v-if="
                (!saveFiltersBool && totalUsers.length == 0) ||
                  (!saveFiltersBool && totalUsers == 0)
              "
            ></div>
            <v-skeleton-loader
              v-else-if="saveFiltersBool"
              type="heading"
              style="width: 300px"
            ></v-skeleton-loader>
            <div v-else class="d-flex align-end subtitle-1 py-0">
              <v-icon left size="32px">mdi-account</v-icon>
              <div>{{ $t("users") }}: {{ totalUsers }}</div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="10"
        hide-default-footer
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
        </template>

        <template v-slot:item.nome="{ item }">
          <v-icon left :color="statusPlayerColorIcon" size="10"
            >mdi-circle</v-icon
          >
          <a
            @click="
              $router.push({
                name: 'AdministratorAccountabilityOnlinePlayersOnlineSearch',
                query: { id_user: item.id },
              })
            "
            >{{ item.nome }}</a
          >
        </template>

        <template v-slot:item.email="{ item }">
          {{ item.email ? item.email : $t("notRegisteredEmail") }}
        </template>

        <template v-slot:item.celular="{ item }">
          <div class="d-flex align-center">
            <!-- copy -->
            <v-btn @click="$copy(item.celular)" x-small>
              <span style="font-size: 1.1em">{{ item.celular }}</span>
            </v-btn>
            <!-- whatsapp -->
            <v-btn
              class="ml-2"
              x-small
              :href="`https://wa.me/+55${item.celular}?text=Olá ${item.nome}`"
              target="_blank"
            >
              <v-icon small>mdi-whatsapp</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn-toggle dense>
            <MenuDropdownStatusUser
              :id_user="item.id"
              @setLoading="setLoading"
            />
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small v-bind="attrs" v-on="on">
                  <v-icon>mdi-email-outline</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="resendConfirmation('Sms', item.id)">
                  <v-list-item-title>{{ $t("resentSMS") }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :disabled="!item.email"
                  @click="resendConfirmation('Email', item.id)"
                >
                  <v-list-item-title>{{ $t("resentEmail") }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-btn-toggle>
        </template>
      </v-data-table>
      <template>
        <v-divider></v-divider>
        <v-footer
          v-if="items.length > 0"
          style="font-size: 0.75rem; background: rgba(0, 0, 0, 0.01)"
          class="d-flex justify-end px-2 py-0"
        >
          <div class="d-flex align-center" style="margin: 11px 0px 10px 0px">
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.smAndDown ? 'd-flex' : ''"
            >
              <div class="d-flex pl-0 pr-0 mr-7">
                <div>{{ $t("page") }}:</div>
                <div class="ml-2">{{ currentPage }}</div>
              </div>
              <div class="pl-0 pr-0 mr-7">
                {{ currentUsersStart }}-{{ currentUsersEnd }} {{ $t("of") }}
                {{ totalUsers }}
              </div>
            </div>
            <div>
              <v-btn
                depressed
                icon
                @click="changePage('preview')"
                :disabled="disableBtnPreview || loading"
              >
                <v-icon> mdi-chevron-left </v-icon>
              </v-btn>
            </div>
            <div style="margin-left: 13px">
              <v-btn
                depressed
                icon
                @click="changePage('next')"
                :disabled="disableBtnNext || loading"
              >
                <v-icon> mdi-chevron-right </v-icon>
              </v-btn>
            </div>
          </div>
        </v-footer>
      </template>
    </v-card>
  </div>
</template>
<script>
import { UFbyDDD } from "@/util/ddd.js";
import MenuDropdownStatusUser from "@/components/administrator/menu/dropdownStatusUser.vue";
export default {
  components: {
    MenuDropdownStatusUser,
  },
  data: () => ({
    currentPage: "",
    items: [],
    headers: [],
    search: "",
    page: 1,
    totalUsers: "",
    disableBtnPreview: true,
    disableBtnNext: true,
    displayedUsers: 0,
    currentUsersEnd: 0,
    saveFiltersBool: false,
    currentUsersStart: 1,
    statusPlayerColorIcon: "green",
  }),
  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    statusPlayers() {
      return this.$store.state.filters.selectStatusPlayers.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    sinalOption() {
      return this.$store.state.filters.sinal.option;
    },
    sinalValor() {
      return this.$store.state.filters.sinal.valor;
    },
    sinalDepositOption() {
      return this.$store.state.filters.sinalDeposit.option;
    },
    sinalDepositValor() {
      return this.$store.state.filters.sinalDeposit.valor;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    depositValueFilter() {
      return this.$store.state.filters.depositValue;
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    id_affiliated() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
  },
  mounted() {
    this.buildHeaders();
  },
  watch: {
    saveFilters(val) {
      this.page = 1;
      if (this.$route.name === "ListPlayersOnline") {
        this.saveFiltersBool = true;
        val && this.getListPlayers();
        this.currentUsersStart = 1;

        // esse if seta essas variavies para a manipulacao do skeleton-loader
        if (this.exportDoc != "") {
          this.totalUsers = 0;
          this.saveFiltersBool = false;
        }
      }
    },
    currentPage(val) {
      this.disableBtnPreview = val == 1 ? true : false;
    },
    displayedUsers(val) {
      if (val === 10) {
        this.disableBtnNext = true;
      } else {
        this.disableBtnNext = val < 10;
      }
    },
    refresh(val) {
      val && this.getListPlayers();
      this.$store.commit("setRefresh", false);
    },
  },

  methods: {
    setLoading(val) {
      this.loading = val;
    },
    async getListPlayers() {
      this.loading = true;
      const body = {
        ...this.rangeDate,
        status: this.statusPlayers,
        page: this.page,
        sinal_option_deposito: this.sinalDepositOption,
        sinal_valor_deposito: this.sinalDepositValor,
        sinal_option_saldo: this.sinalOption,
        sinal_valor_saldo: this.sinalValor,
        export: this.exportDoc,
        deposit_value_option: this.depositValueFilter.value
          ? this.depositValueFilter.option
          : "",
        deposit_value: this.depositValueFilter.option
          ? this.depositValueFilter.value
          : "",
        id_affiliated: this.id_affiliated,
      };

      let response;
      if (this.exportDoc) {
        this.items = [];
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "/administrator/players/listOnlinePlayers",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/administrator/players/listOnlinePlayers",
          body
        );
      }

      this.loading = false;

      // reset
      if (!response.dados) {
        this.totalUsers = 0;
        this.saveFiltersBool = false;
        this.loading = false;
        this.items = [];
        return;
      }
      this.currentPage = response.this_page;

      this.items = response.dados;
      this.items.forEach((item) => {
        item.data_cadastro = new Date(
          item.data_cadastro.replace(" ", "T")
        ).toLocaleString();
        item.email ? item.email : (item.email = false);
        item.uf = UFbyDDD[Number(item.celular.slice(0, 2))];
      });

      // Inserindo e Colocando a Coluna Actions de acordo com o get;
      var boolActions = this.headers.some(
        (element) => element.value === "actions"
      );
      if (this.statusPlayers == 5 && !boolActions) {
        this.statusPlayerColorIcon = "orange";
        this.headers.push({
          text: this.$t("actions"),
          value: "actions",
          align: "center",
          sortable: false,
        });
      } else if (this.statusPlayers != 5 && boolActions) {
        this.statusPlayerColorIcon = "green";
        this.headers.pop();
      }

      await this.$request
        .post("/administrator/players/totalOnlinePlayers", body)
        .then((response) => {
          if (!response.dados) return;
          this.totalUsers = response.dados.total_users;

          this.displayedUsers = this.totalUsers / this.currentPage;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.saveFiltersBool = false;
          this.currentUsersEnd = 10 * this.currentPage;
          if (this.currentUsersEnd > this.totalUsers) {
            this.currentUsersEnd = this.totalUsers;
          }
          this.loading = false;
        });
    },

    changePage(page) {
      if (page == "next") {
        this.page = this.currentPage + 1;
        this.currentUsersStart += 10;
        this.scrollToTop();
      }

      if (page == "preview") {
        this.page = this.currentPage - 1;
        this.currentUsersStart -= 10;
        this.scrollToTop();
      }
      this.getListPlayers();
    },
    // scroll function
    scrollToTop() {
      document
        .getElementById("scrollToTop")
        .scrollIntoView({ behavior: "smooth" });
    },

    // resendConfirmation
    async resendConfirmation(type, id_user) {
      const body = {
        id_user: id_user,
      };
      const response = await this.$request.post(
        `administrator/players/resend${type}`,
        body
      );
      if (response.length == 0) return;
      this.$store.commit("setFeedbackSnack", {
        msg: response.messages,
        color: "success",
      });
    },
    // Construindo os headers aqui, para facilitar a manipulação da
    // coluna 'Actions'
    buildHeaders() {
      this.headers = [
        {
          text: this.$t("idLabel"),
          value: "id",
          align: " caption",
          sortable: false,
        },
        {
          text: this.$t("name"),
          value: "nome",
          align: "",
          sortable: false,
        },
        {
          text: this.$t("dtRegistration"),
          value: "data_cadastro",
          align: " caption",
          sortable: false,
        },
        {
          text: "UF",
          value: "uf",
          align: " caption",
          sortable: false,
        },
        {
          text: this.$t("cellPhone"),
          value: "celular",
          align: " caption",
          sortable: false,
        },
        {
          text: this.$t("labelLogin"),
          value: "login",
          align: " caption",
          sortable: false,
        },
        {
          text: "E-mail",
          value: "email",
          align: " caption",
          sortable: false,
        },
        {
          text: this.$t("depositBalance"),
          value: "saldo_online",
          align: " caption",
          sortable: false,
        },
        {
          text: this.$t("bonusBalance"),
          value: "saldo_bonus",
          align: " caption",
          sortable: false,
        },
      ];
    },
  },
};
</script>
